import { call, put } from "redux-saga/effects";
import { courseAPI } from "@services/api";
import { getSavedCoursesActions } from "../slices";

function* getSavedCoursesWorker() {
  try {
    yield put(getSavedCoursesActions.pending());
    const response = yield call(courseAPI.getSavedCourses);
    const payload = {
      pagination: response.pagination,
      savedCourses: response.data.data,
    };
    yield put(getSavedCoursesActions.success(payload));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getSavedCoursesActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

function* getMoreSavedCoursesWorker({ payload }) {
  try {
    const response = yield call(courseAPI.getSavedCourses, payload.pageNumber);
    // TODO: handle callback | onSuccess
    const { data: savedCourses } = response.data;
    const data = {
      savedCourses: savedCourses || [],
      pagination: response.pagination,
    };
    yield put(getSavedCoursesActions.getMoreSuccess(data));
  } catch (error) {
    yield put(getSavedCoursesActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getSavedCoursesWorker, getMoreSavedCoursesWorker };
